import { render, staticRenderFns } from "./ProblemAnalysis.vue?vue&type=template&id=4b5ecaaf&"
import script from "./ProblemAnalysis.vue?vue&type=script&lang=js&"
export * from "./ProblemAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ProblemAnalysis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProblemAnalysis.vue"
export default component.exports